(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary"] && !Shopify.designMode) return;
  try {
    

const handleIntersection = ( entries , observer ) => {

if ( !entries[0].isIntersecting ) return;

observer.unobserve( complementary );

const url = complementary.dataset.url;

fetch( url )

.then(

response => response.text()

)

.then(

text => {

const html = document.createElement( 'div' );

html.innerHTML = text;

const recommendations = html.querySelector( '.complementary' );

if ( recommendations && recommendations.innerHTML.trim().length ) {

complementary.innerHTML = recommendations.innerHTML;

}

}

)

.catch(

e => {

console.error( e );

}

);

};

const complementary = document.querySelector( '.complementary' );

const observer = new IntersectionObserver(

handleIntersection,

{

rootMargin: '0px 0px 200px 0px'

}

);

observer.observe( complementary );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

  function bind() {
    var myCarousel = document.querySelector('#product-carousel');
    if (myCarousel && typeof bootstrap !== 'undefined' && window.innerWidth < 992) {
      new bootstrap.Carousel(myCarousel, {
        interval: 4000,
        ride: 'carousel'
      });
    }

    document.querySelectorAll('#product-carousel .carousel-item').forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      item.addEventListener('mousemove', function (e) {
        if (window.innerWidth < 992) return;
        var r = item.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' +
          ((e.clientY - r.top) / r.height * 100) + '%';
        item.classList.add('zooming');
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('zooming');
      });
    });

    var element = document.querySelector( '#product' );

    document
    
      .querySelectorAll( '[data-section]' )
        
      .forEach(

        function ( link ) {

          link

            .addEventListener(

              'click',

              function ( event ) {

                event.preventDefault();

                var url = link.href + '&section_id=' + link.dataset.section;

                console.log( url );

                fetch( url )

                  .then(
                    
                    response => response.text()
                    
                  )

                  .then(
                    
                    text => {

                      const html = document.createElement('div');

                      html.innerHTML = text;

                      const product = html.querySelector( '#product' );
                      
                      console.log( product );

                      if ( product && product.innerHTML.trim().length ) {

                        element.innerHTML = product.innerHTML;

                        bind();

                      }

                    }
                    
                  )

                  .catch(
                    
                    e => {

                      console.error( e );

                    }
                    
                  );
                
              }

            );
          
        }

      );
    
  }

  document
    
    .addEventListener(

      'DOMContentLoaded',

      function() {

        bind();

      }

    );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related"] && !Shopify.designMode) return;
  try {
    

  const handleIntersection = ( entries , observer ) => {

    if ( !entries[0].isIntersecting ) return;

    observer.unobserve( related );

    const url = related.dataset.url;

    fetch( url )

      .then(
        
        response => response.text()
        
      )

      .then(
        
        text => {

          const html = document.createElement( 'div' );

          html.innerHTML = text;

          const recommendations = html.querySelector( '.related' );

          if ( recommendations && recommendations.innerHTML.trim().length ) {

            related.innerHTML = recommendations.innerHTML;

          }

        }
        
      )

      .catch(
        
        e => {

          console.error( e );

        }
        
      );

  };

  const related = document.querySelector( '.related' );

  const observer = new IntersectionObserver(
    
    handleIntersection,
    
    {
      
      rootMargin: '0px 0px 200px 0px'
    
    }
    
  );

  observer.observe( related );


  } catch(e) { console.error(e); }
})();
})();
